import { render, staticRenderFns } from "./vatReport.vue?vue&type=template&id=3d6b2ac6"
import script from "./vatReport.vue?vue&type=script&lang=js"
export * from "./vatReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports